// import {Calendar} from '@fullcalendar/core';
// import interactionPlugin from '@fullcalendar/interaction';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import listPlugin from '@fullcalendar/list';
// import bootstrapPlugin from '@fullcalendar/bootstrap';
import * as angular from "angular";

export default angular.module('obto.data.calendar', ['obto.data.service', 'ui.bootstrap'])//, 'ui.bootstrap'
    .controller('CalendarCtrl', ['$scope', '$log', '$routeParams', '$rootScope', '_', 'CalendarEvent', function ($scope, $log, $routeParams, $rootScope, _, CalendarEvent) {
        $scope.icon = "";
        $scope.newEvent = {};
        $scope.events = [];
        $scope.myClass = _.isUndefined($rootScope.myClass) ? {label: "", value: ""} : $rootScope.myClass;
        $scope.showSelection = false;
        $scope.istimetable = false;
        $scope.stretch = 9;
        $scope.visibleside = true;
        $scope.newEvent.isglobal = false;
        
        $scope._editable = false;
        $scope._draggable = false;
        $scope._selectable = false;
        $scope._disableResizing = true;
        $scope.view = "agendaWeek";
        $scope.controls = 'today';
        
        $scope.viewOptions = {
            agendaWeek: 'Week'
        };
        $scope.viewOptionsText = 'agendaWeek';
        $scope.istimetable = $scope.istimetable !== "false";
        
        const getTime = function (period) {
            if (period === 1) {
                return {start: " 08:00:00", end: " 08:45:00", className: "bg-color-blue txt-color-white"};
            }
            if (period === 2) {
                return {start: " 08:45:00", end: " 09:30:00", className: "bg-color-greenLight txt-color-white"};
            }
            if (period === 3) {
                return {start: " 09:30:00", end: " 10:15:00", className: "bg-color-orange txt-color-white"};
            }
            if (period === 4) {
                return {start: " 10:15:00", end: " 11:00:00", className: "bg-color-red txt-color-white"};
            }
            if (period === 5) {
                return {start: " 11:00:00", end: " 11:45:00", className: "bg-color-darken txt-color-white"};
            }
            if (period === 6) {
                return {start: " 11:45:00", end: " 12:30:00", className: "bg-color-blueLight txt-color-white"};
            }
            if (period === 7) {
                return {start: " 12:30:00", end: " 13:15:00", className: "bg-color-greenLight txt-color-white"};
            }
            if (period === 8) {
                return {start: " 13:15:00", end: " 14:00:00", className: "bg-color-orange txt-color-white"};
            }
        };
        
        const successCallback = function (html) {
            $log.log("Calendar updated");
            // $.smallBox({
            //     title: "Calendar updated",
            //     content: "<i class='fa fa-clock-o'></i> <i>just now...</i>",
            //     color: "#298A08",
            //     iconSmall: "fa fa-warning shake animated",
            //     timeout: 3000
            // });
            
        };
        
        const processEvents = function (events) {
            console.log('events', events);
            _.each(events, function (val, key) {
                //$log.log(val.start);
                events[key].className = val.class_name;
                delete events[key].class_name;
                events[key].icon = val.icon;
                events[key].start = val.start;//moment.tz(val.start, $rootScope.timezone);
                events[key].end = val.end;//moment.tz(val.end, $rootScope.timezone);
                events[key].description = "";
                events[key].id = val._id;
                if (key === 'hash_key') {
                    events['$$hashKey'] = 'object:1234';
                    delete events.hash_key;
                }
                
                
            });
            $scope.events = events;
            $scope.options = {
                themeSystem: 'bootstrap',
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                },
                // minTime: '06:30:00',
                // maxTime: '19:30:00',
                initialDate: '2018-01-12',
                navLinks: true, // can click day/week names to navigate views
                editable: true,
                dayMaxEvents: true, // allow "more" link when too many events
                hiddenDays: [0],
                droppable: true, // this allows things to be dropped onto the calendar
                drop: function (info) {
                    // is the "remove after drop" checkbox checked?
                    if (checkbox.checked) {
                        // if so, remove the element from the "Draggable Events" list
                        info.draggedEl.parentNode.removeChild(info.draggedEl);
                    }
                },
                dateClick: function (info) {
                    alert('clicked ' + info.dateStr);
                },
                select: function (info) {
                    alert('selected ' + info.startStr + ' to ' + info.endStr);
                }
            };
            console.log($scope.events.length);
        };
        
        const processEventsClassSchedule = function (events) {
            
            var view = $('#calendar').fullCalendar('getView');
            //var calendar_day = moment.tz(view.start, "Atlantic/Reykjavik").day().toString();
            var startDate = view.start;
            
            const monday = function (c) {
                async.forEachOf(events, function (val, key, cb) {
                    var time = getTime(val.period);//clone().tz($rootScope.timezone)
                    var printDate = moment.tz(startDate, "Atlantic/Reykjavik").format("YYYY-MM-DD");
                    var calculateDate = moment.tz(startDate, "Atlantic/Reykjavik").toISOString();
                    var calendar_day = moment.tz(calculateDate, "Atlantic/Reykjavik").day();
                    //console.log(printDate + calendar_day + val.day);
                    if (val.day === "monday" && calendar_day === "1") {
                        events[key].start = printDate + time.start;
                        events[key].end = printDate + time.end;
                        events[key].title = val.period + " - " + val.subject.label;
                        events[key].description = val.period + " - " + val.subject.label;
                        events[key].id = val._id;
                        events[key].className = time.className;
                        delete events[key].subject;
                        delete events[key].period;
                        delete events[key].name;
                        delete events[key].day;
                    }
                    cb();
                }, function (err) {
                    c(null, 1);
                });
            };
            
            const tuesday = function (c) {
                async.forEachOf(events, function (val, key, cb) {
                    var time = getTime(val.period);
                    var printDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 1).format("YYYY-MM-DD");
                    var calculateDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 1).toISOString();
                    var calendar_day = moment.tz(calculateDate, "Atlantic/Reykjavik").day();
                    if (val.day == "tuesday" && calendar_day == "2") {
                        events[key].start = printDate + time.start;
                        events[key].end = printDate + time.end;
                        events[key].title = val.period + " - " + val.subject.label;
                        events[key].description = val.period + " - " + val.subject.label;
                        events[key].id = val._id;
                        events[key].className = time.className;
                        delete events[key].subject;
                        delete events[key].period;
                        delete events[key].name;
                        delete events[key].day;
                    }
                    cb();
                }, function (err) {
                    c(null, 2);
                });
            };
            
            const wednesday = function (c) {
                async.forEachOf(events, function (val, key, cb) {
                    var time = getTime(val.period);
                    var printDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 2).format("YYYY-MM-DD");
                    var calculateDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 2).toISOString();
                    var calendar_day = moment.tz(calculateDate, "Atlantic/Reykjavik").day();
                    //console.log(printDate + calendar_day + val.day);
                    if (val.day === "wednesday" && calendar_day == "3") {
                        events[key].start = printDate + time.start;
                        events[key].end = printDate + time.end;
                        events[key].title = val.period + " - " + val.subject.label;
                        events[key].description = val.period + " - " + val.subject.label;
                        events[key].id = val._id;
                        events[key].className = time.className;
                        delete events[key].subject;
                        delete events[key].period;
                        delete events[key].name;
                        delete events[key].day;
                    }
                    cb();
                }, function (err) {
                    c(null, 3);
                });
            };
            
            const thursday = function (c) {
                async.forEachOf(events, function (val, key, cb) {
                    var time = getTime(val.period);
                    var printDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 3).format("YYYY-MM-DD");
                    var calculateDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 3).toISOString();
                    var calendar_day = moment.tz(calculateDate, "Atlantic/Reykjavik").day();
                    //console.log(printDate + calendar_day + val.day);
                    if (val.day == "thursday" && calendar_day == "4") {
                        events[key].start = printDate + time.start;
                        events[key].end = printDate + time.end;
                        events[key].title = val.period + " - " + val.subject.label;
                        events[key].description = val.period + " - " + val.subject.label;
                        events[key].id = val._id;
                        events[key].className = time.className;
                        delete events[key].day;
                        delete events[key].subject;
                        delete events[key].period;
                        delete events[key].name;
                    }
                    cb();
                }, function (err) {
                    c(null, 4);
                });
            };
            
            const friday = function (c) {
                async.forEachOf(events, function (val, key, cb) {
                    var time = getTime(val.period);
                    var printDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 4).format("YYYY-MM-DD");
                    var calculateDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 4).toISOString();
                    var calendar_day = moment.tz(calculateDate, "Atlantic/Reykjavik").day();
                    //console.log(printDate + calendar_day + val.day);
                    if (val.day === "friday" && calendar_day === "5") {
                        events[key].start = printDate + time.start;
                        events[key].end = printDate + time.end;
                        events[key].title = val.period + " - " + val.subject.label;
                        events[key].description = val.period + " - " + val.subject.label;
                        events[key].id = val._id;
                        events[key].className = time.className;
                        delete events[key].subject;
                        delete events[key].period;
                        delete events[key].name;
                        delete events[key].day;
                    }
                    cb();
                }, function (err) {
                    c(null, 5);
                });
            };
            
            const saturday = function (c) {
                async.forEachOf(events, function (val, key, cb) {
                    var time = getTime(val.period);
                    var printDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 5).format("YYYY-MM-DD");
                    var calculateDate = moment.tz(startDate, "Atlantic/Reykjavik").add("days", 5).toISOString();
                    var calendar_day = moment.tz(calculateDate, "Atlantic/Reykjavik").day();
                    //console.log(printDate + calendar_day + val.day);
                    if (val.day === "saturday" && calendar_day === "6") {
                        events[key].start = printDate + time.start;
                        events[key].end = printDate + time.end;
                        events[key].title = val.period + " - " + val.subject.label;
                        events[key].description = val.period + " - " + val.subject.label;
                        events[key].id = val._id;
                        events[key].className = time.className;
                        delete events[key].subject;
                        delete events[key].period;
                        delete events[key].name;
                        delete events[key].day;
                    }
                    cb();
                }, function (err) {
                    c(null, 6);
                });
            };
            
            async.parallel([monday, tuesday, wednesday, thursday, friday, saturday], function (err, result) {
                //scope.events = events;
                $scope.events = events;
                $timeout(function () {
                    $scope.$digest();
                }, 3000);
            });
            
        };
        
        $scope.view = "month";
        $scope._editable = true;
        $scope._draggable = true;
        $scope.controls = 'prev, next, today';
        $scope.viewOptionsText = 'month, agendaWeek, agendaDay';
        $scope._selectable = true;
        $scope._disableResizing = false;
        $scope.viewOptions = {
            month: 'Month',
            agendaWeek: 'Week',
            agendaDay: 'Day'
        };
        CalendarEvent.query().$promise.then(processEvents);
        
        // if (!$scope.istimetable || _.isUndefined($scope.istimetable)) {
        //     $scope.view = "month";
        //     $scope._editable = true;
        //     $scope._draggable = true;
        //     $scope.controls = 'prev, next, today';
        //     $scope.viewOptionsText = 'month, agendaWeek, agendaDay';
        //     $scope._selectable = true;
        //     $scope._disableResizing = false;
        //     $scope.viewOptions = {
        //         month: 'Month',
        //         agendaWeek: 'Week',
        //         agendaDay: 'Day'
        //     };
        //     CalendarEvent.query().$promise.then(processEvents);
        //
        // } else {
        //     if (_.isUndefined($rootScope.myClass)) {
        //         //initCalendar();
        //         $scope.$watch('myclass', function (n, o) {
        //             if (!_.isUndefined(n) && n.label !== o.label) {
        //                 // console.log("My Class : 1 " + JSON.stringify(scope.myclass));
        //                 ClassSchedule.query({"oquery": "class.label=" + $scope.myclass.label}).$promise.then(processEventsClassSchedule);
        //             }
        //         });
        //     } else {
        //         console.log("My Class : 2 " + $scope.myclass);
        //         ClassSchedule.query({"oquery": "class.label=" + $rootScope.myClass.label}).$promise.then(processEventsClassSchedule);
        //     }
        // }
        
        if (!_.isUndefined($routeParams.istimetable)) {
            $scope.istimetable = ($routeParams.istimetable !== "false");
            
        }
        
        if (_.isUndefined($routeParams.istimetable)) {
            $scope.istimetable = false;
            $scope.stretch = 9;
            $scope.visibleside = true;
        }
        
        if (_.isUndefined($rootScope.myClass) && $scope.istimetable) {
            $scope.showSelection = true;
        }
        if ($scope.istimetable) {
            $scope.stretch = 12;
            $scope.visibleside = false;
        }
        
        $scope.printme = function () {
            html2canvas($('#calendar'), {
                onrendered: function (canvas) {
                    var imgData = canvas.toDataURL(
                        'image/jpeg');
                    console.log(imgData);
                    var doc = new jsPDF('l', 'mm', 'legal');
                    doc.addImage(imgData, 'PNG', 15, 15, 320, 250);
                    doc.save('timetable.pdf');
                }
            });
        };
        
        // Unassigned events scope
        $scope.eventsExternal = [
            {
                title: "Teacher's Meeting",
                description: "Currently busy",
                className: "bg-color-darken txt-color-white",
                icon: "fa-time",
                user: {
                    label: $rootScope.userfullname,
                    value: $rootScope.userid
                }
            },
            {
                title: "Lunch Break",
                description: "No Description",
                className: "bg-color-blue txt-color-white",
                icon: "fa-pie",
                user: {
                    label: $rootScope.userfullname,
                    value: $rootScope.userid
                }
            },
            {
                title: "Urgent Meeting",
                description: "urgent tasks",
                className: "bg-color-red txt-color-white",
                icon: "fa-alert",
                user: {
                    label: $rootScope.userfullname,
                    value: $rootScope.userid
                }
            }
        ];
        
        $scope.$watch('newEvent', function (n, o) {
            
            $log.log("Adding new event:", JSON.stringify($scope.newEvent));
            console.log($scope.newEvent.isglobal);
            
        }, true);
        
        $scope.addEvent = function () {
            
            $log.log("Adding new event:", $scope.newEvent);
            
            var newEventDefaults = {
                title: "Untitled Event",
                description: "no description",
                className: "bg-color-darken txt-color-white",
                icon: "fa-info",
                user: {
                    label: $rootScope.userfullname,
                    value: $rootScope.userid
                }
            };
            
            if ($scope.newEvent.isglobal) {
                $scope.newEvent.user = {
                    label: "Global",
                    value: "global"
                };
            }
            
            angular.extend(newEventDefaults, $scope.newEvent);
            $scope.eventsExternal.push(newEventDefaults);
            $scope.newEvent = {};
        };
        
        
    }])
    .directive('fullCalendar', ['CalendarEvent', '$log', '$timeout', '_', 'moment', '$rootScope', '$http', 'ClassSchedule', 'async', function (CalendarEvent, $log, $timeout, _, moment, $rootScope, $http, ClassSchedule, async) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: viewFiles + '/full-calendar.tpl.html',
            scope: {
                events: "=",
                istimetable: "@",
                options: "="
            },
            link: function (scope, element) {
                // Now events will be refetched every time events scope is updated in controller!!!
                // const options = {
                //     plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin, bootstrapPlugin],
                //     handleWindowResize: false
                // };
                
                // const initiate = () => {
                //     setTimeout(() => {
                //         // options = Object.assign(scope.options, options);
                //         scope.options.plugins = options.plugins;
                //         scope.options.handleWindowResize = false;
                //         console.log('Calendar options', scope.options);
                //         const calendarEl = document.getElementById('calendar');
                //         console.log('calendarEl', calendarEl);
                //         const calendar = new Calendar(calendarEl, scope.options);
                //         console.log('rendering..');
                //         calendar.render();
                //         calendar.updateSize();
                //     }, 500);
                // };
                
                // scope.$on('event:resize:calendar', () => {
                //     initiate();
                // });
                
                // scope.$watch('options', function (newValue, oldValue) {
                //     if (newValue !== oldValue) {
                //         initiate();
                //     }
                // });
            }
        };
    }])
    .directive('dragableEvent', ['$log', function ($log) {
        return {
            restrict: 'A',
            link: function (scope, element) {
    
                const eventObject = element.scope().event;
                
                element.data('eventObject', eventObject);
                
                element.draggable({
                    zIndex: 12999,
                    revert: true, // will cause the event to go back to its
                    revertDuration: 0 //  original position after the drag
                });
            }
        };
    }]);

